export default class S3PermissionDeniedError extends Error {
  constructor() {
    super('No permissioning when accessing S3');
  }
}
